import { Stack, Group, Text, Grid, EmptyState } from '../../../../components/ui';
import { IconActivity } from '@tabler/icons-react';
import { HealthCheckCard } from './HealthCheckCard';
import type { HealthChecksTabProps } from '../types';

export function HealthChecksTab({ entries }: HealthChecksTabProps) {
  const entryKeys = Object.keys(entries);

  if (entryKeys.length === 0) {
    return (
      <EmptyState
        icon={<IconActivity size={64} />}
        title="No Health Checks"
        description="No health check entries are available."
      />
    );
  }

  return (
    <Stack gap="md">
      <Group gap="sm">
        <IconActivity size={20} />
        <Text size="md" fw={600}>
          Detailed Health Checks
        </Text>
      </Group>

      <Grid>
        {entryKeys.map((name) => (
          <Grid.Col key={name} span={{ base: 12, sm: 6, md: 4 }}>
            <HealthCheckCard name={name} entry={entries[name]} />
          </Grid.Col>
        ))}
      </Grid>
    </Stack>
  );
}
